import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {NewsDtoExtended} from '../../modules/interfaces/news-extended.interface';


export const newsEntitiesAdapter: EntityAdapter<NewsDtoExtended> = createEntityAdapter<NewsDtoExtended>({
  selectId: (NewsEntity: NewsDtoExtended) => NewsEntity.id!,
});
